import script from "./ConsentFields.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsentFields.vue?vue&type=script&setup=true&lang=js"

import "./ConsentFields.vue?vue&type=style&index=0&id=16d88878&lang=css"

const __exports__ = script;

export default __exports__